import { render, staticRenderFns } from "./BaseFieldText.vue?vue&type=template&id=6062086e&"
import script from "./BaseFieldText.vue?vue&type=script&lang=js&"
export * from "./BaseFieldText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6062086e')) {
      api.createRecord('6062086e', component.options)
    } else {
      api.reload('6062086e', component.options)
    }
    module.hot.accept("./BaseFieldText.vue?vue&type=template&id=6062086e&", function () {
      api.rerender('6062086e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/forms/BaseFieldText.vue"
export default component.exports